import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function SecurePaymentBadge() {
  return <div className="flex flex-col items-center justify-center gap-3 py-6" data-id="element-188">
      <div className="flex items-center gap-3 text-[#2D241E]" data-id="element-189">
        <ShieldCheck className="w-6 h-6 text-[#7C2D2D]" data-id="element-190" />
        <span className="font-serif text-lg font-medium" data-id="element-191">
          Pago seguro procesado por:
        </span>
      </div>
      <div className="bg-white px-6 py-3 rounded-sm shadow-md border-2 border-[#8B4513]/20" data-id="element-192">
        <img src="https://cdn.magicpatterns.com/uploads/amC6vuhtuqQMcHysHZenxK/ML.jpg" alt="Mercado Libre" className="h-8 w-auto" data-id="element-193" />
      </div>
    </div>;
}